<template>
  <div class="new_vip">
    <div class="content">
      <div class="top">
        选择门店：<el-select v-model="param.room_id" placeholder="全部门店" size="small">
          <el-option
            v-for="item in store_options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span style="margin-left:30px;">
          选择时间：
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            size="small">
          </el-date-picker>
        </span>
      </div>
      <div class="part_title">
        <!-- <div class="title_line"></div> -->
        <span>总览</span>
      </div>
      <div class="stat_box">
        <div class="stat_item" style="background: #3F61ED">
          <div class="stat_name">总金额（元）</div>
          <div class="stat_value">0</div>
        </div>
        <div class="stat_item" style="background: #00AFFF">
          <div class="stat_name">汽油</div>
          <div class="stat_value">0</div>
        </div>
        <div class="stat_item" style="background: #1CD5AC">
          <div class="stat_name">柴油</div>
          <div class="stat_value">0</div>
        </div>
        <div class="stat_item" style="background: #7A5EE1">
          <div class="stat_name">充值（元）</div>
          <div class="stat_value">0</div>
        </div>
        <div class="stat_item" style="background: #E1795E">
          <div class="stat_name">非油品</div>
          <div class="stat_value">0</div>
        </div>
      </div>
      <div class="part_line"></div>
      <div class="part_title">
        <span>订单来源百分比</span>
      </div>
      <div id="container"></div>
      <div class="part_line"></div>
      <div class="part_title">
        <span>商品看板</span>
      </div>
      <div class="table_box">
        <div class="table_item" style="margin-right:10px;">
          <div class="table_title">TOP5访问排行</div>
          <el-table :data="watchList">
            <el-table-column label="商品" prop="name"></el-table-column>
            <el-table-column label="访客数" prop="num"></el-table-column>
            <el-table-column label="访问-支付转化率" prop="percent"></el-table-column>
          </el-table>
        </div>
        <div class="table_item">
          <div class="table_title">TOP5访问排行</div>
          <el-table :data="payList">
            <el-table-column label="商品" prop="name"></el-table-column>
            <el-table-column label="支付件数" prop="num"></el-table-column>
            <el-table-column label="支付金额" prop="money"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee"
import { general } from "@/api/vip";
import echarts from 'echarts';
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      store_options: [], //门店选项
      loading: false, //页面loading
      param: {
        room_id: "", //选择的门店
      },
      watchList: [],
      payList: [],
      dateValue: [], //时间段筛选
      statData: {}, //统计数据
      pickerOptions: { //时间快捷选项
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      this.loading = true;
      storeSelect({token:this.token,app_id:this.app_id}).then(res=>{
        if(res.code == 200){
          this.store_options = res.data;
          this.store_options.unshift({id: "0",name: "全部门店"});
          this.param.room_id = "0";
          this.loading = false;
        }else{
          // this.$message({
          //   type: "error",
          //   message: "获取门店列表失败，请刷新重试"
          // })
        }
      })
      general({token:this.token,app_id:this.app_id}).then(res => {
        if(res.code == 200){
          this.statData = res.data;
          console.log(this.statData)
        }
      })
      this.createCharts();
    },
    //创建echarts图
    createCharts(){
      var dom = document.getElementById("container");
      var myChart = echarts.init(dom);
      var app = {};
      var option = null;
      option = {
        title: {
          text: '订单来源百分比',
          left: 'center'
      },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
        },
        series : [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            data:[
              {value:235, name:'视频广告'},
              {value:274, name:'联盟广告'},
              {value:310, name:'邮件营销'},
              {value:335, name:'直接访问'},
              {value:400, name:'搜索引擎'}
            ]
          }
        ]
      };;
      myChart.setOption(option, true);
    }
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  width: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content{
    background: #fff;
    width: 100%;
    height: 100%;
    overflow: auto;
    .part_line{
      background: #f1f2f6;
      height: 10px;
    }
    .top{
      padding:24px 24px 0 24px;
    }
    .part_title{
      padding: 20px;
      font-weight: bold;
      // background: #f5f5f5;
      font-size: 15px;
      .title_line{
        display: inline-block;
        margin-top: 10px;
        height: 14px;
        background: #00D1A1;
        width: 4px;
        border-radius: 2px;
        margin-right: 10px;
        vertical-align: top;
      }
    }
    .stat_box{
      padding: 0 20px 18px 20px;
      display: flex;
      .stat_item{
        width: 173px;
        margin-right: 10px;
        // display: flex;
        height: 65px;
        border-radius: 3px;
        padding:13px 0;
        text-align: center;
        color: #fff;
        .stat_name{
          height: 17px;
          line-height: 17px;
          margin-bottom: 2px;
        }
        .stat_value{
          height: 20px;
          line-height: 20px;
          font-size: 14px;
        }
        .stat_item_left{
          flex:2;
          border-right: 1px solid #fff;
        }
        .stat_item_right{
          flex:3;
        }
        .stat_item_line{
          line-height: 33px;
          text-align: center;
          span{
            font-weight: blod;
          }
        }
      }
    }
    #container{
      width: 100%;
      height: 320px;
      padding:0 15px;
      background: #fff;
    }
    .table_box{
      padding: 0 24px 18px 24px;
      display: flex;
      justify-content: space-between;
      .table_item{
        flex:1;
        background: #f5f5f5;
        border:1px solid rgba(0,0,0,0.15);
        border-radius: 4px;
        .table_title{
          background: #f8f8f8;
          height: 40px;
          line-height: 40px;
          padding-left: 16px;
          color:rgba(0,0,0,0.65);
        }
      }
    }
  }
}
</style>